import { Injectable } from "@angular/core";
import { WorkItemEndPoints } from "../../../endpoints/work-item-end-points";
var WorkItemsProvider = /** @class */ (function () {
    function WorkItemsProvider(_workItemEndPoints) {
        this._workItemEndPoints = _workItemEndPoints;
    }
    WorkItemsProvider.prototype.getIdByExternalId = function (externalId) {
        return this._workItemEndPoints.getIdByExternalId(externalId);
    };
    WorkItemsProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    WorkItemsProvider.ctorParameters = function () { return [
        { type: WorkItemEndPoints, },
    ]; };
    return WorkItemsProvider;
}());
export { WorkItemsProvider };
//# sourceMappingURL=work-items-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/items/work-items/work-items-provider.js
// module id = 387
// module chunks = 14